import { isObject, isBoolean, has, isString, isNumber, isArray, isUndefined } from 'lodash';
import LinksCollection from './LinkCollection';

export default class Link {
  constructor(data) {
    this.values = {
      id: null,
      title: null,
      slug: null,
      parent: null,
      subTitle: null,
      lat: null,
      lon: null,
      view: 'regional',
      path: [],
      cameraPos: {},
      details: {},
      children: [],
      timezone: null,
      flightTime: null,
      showPopup: false,
      markerPosition: 'tl',
      type: null,
      markerClass: null,
      sortOrder: 999999,
      navigateTo: null,
      colour: null,
      includeChildrenInNav: false,
      boundaryCoordinates: null,
      overview: null,
    };
    this.setModel(data);
  }

  setModel(link) {
    if (isObject(link)) {
      Object.keys(link).forEach((key) => {
        const datum = has(this.values, key) ? link[key] : null;
        if (datum) {
          this[key](datum);
        }
      });
    }
  }

  title(val) {
    if (isString(val)) {
      this.values.title = val;
      this.slug(val);
    }
    return this.values.title;
  }

  id(val) {
    if (isString(val)) {
      this.values.id = val;
    }
    return this.values.id;
  }

  boundaryCoordinates(val) {
    if (isArray(val)) {
      this.values.boundaryCoordinates = val;
    }

    return this.values.boundaryCoordinates;
  }

  timezone(val) {
    if (isString(val)) {
      this.values.timezone = val;
    }
    return this.values.timezone;
  }

  overview(val) {
    if (isString(val)) {
      this.values.overview = val;
    }
    return this.values.overview;
  }

  flightTime(val) {
    if (isString(val)) {
      this.values.flightTime = val;
    }
    return this.values.flightTime;
  }

  slug() {
    return this.id();
  }

  parent(val) {
    if (isObject(val)) {
      this.values.parent = val;
    }
    return this.values.parent;
  }

  parentTitle() {
    return this.parent().title();
  }

  parentSlug() {
    return this.parent().slug();
  }

  subTitle(val) {
    if (isString(val)) {
      this.values.subTitle = val;
    }
    return this.values.subTitle;
  }

  lat(val) {
    if (isNumber(val)) {
      this.values.lat = val;
    } else if (isUndefined(val) === false) {
      this.values.lat = parseFloat(val);
    }

    return this.values.lat;
  }

  lon(val) {
    if (isNumber(val)) {
      this.values.lon = val;
    } else if (isUndefined(val) === false) {
      this.values.lon = parseFloat(val);
    }

    return this.values.lon;
  }

  view(val) {
    if (isString(val)) {
      this.values.view = val;
    }
    return this.values.view;
  }

  path(val) {
    if (isObject(val)) {
      this.values.path = val;
    }

    return this.values.path;
  }

  cameraPos(val) {
    if (isObject(val)) {
      this.values.cameraPos = val;
    }

    return this.values.cameraPos;
  }

  children(val) {
    if (isArray(val)) {
      this.values.children = new LinksCollection(val, this);
    }

    return this.values.children;
  }

  hasChildren() {
    return this.values.children && this.values.children.list && this.values.children.list().length > 0; // eslint-disable-line max-len
  }

  hasPath() {
    return this.values.path && this.values.path.route && (this.values.path.route.length > 0 || (this.values.path.route.features && this.values.path.route.features.length > 0)); // eslint-disable-line max-len
  }

  details(val) {
    if (isObject(val)) {
      this.values.details = val;
    }

    return this.values.details;
  }

  type(val) {
    if (isString(val)) {
      this.values.type = val;
    }

    return this.values.type;
  }

  markerClass(value) {
    if (isString(value)) {
      this.values.markerClass = value;
    }

    return this.values.markerClass;
  }

  showPopup() {
    return this.details() && this.details().showPopup === true;
  }

  sortOrder(val) {
    if (isNumber(val)) {
      this.values.sortOrder = val;
    }
    return this.values.sortOrder;
  }

  navigateTo(val) {
    if (isString(val)) {
      this.values.navigateTo = val;
      return val;
    }
    let returnVal = this.values.navigateTo;
    if (!returnVal) {
      returnVal = `${this.lat()},${this.lon()},14`;
    }
    return returnVal;
  }

  markerPosition(val) {
    if (isString(val)) {
      this.values.markerPosition = val;
    }
    return this.values.markerPosition;
  }

  colour(val) {
    if (isString(val)) {
      this.values.colour = val;
    }
    return this.values.colour;
  }

  includeChildrenInNav(val) {
    if (isBoolean(val)) {
      this.values.includeChildrenInNav = val;
    }
    return this.values.includeChildrenInNav;
  }
}



// WEBPACK FOOTER //
// ./src/models/Link.js